<gan-spinner></gan-spinner>
<gan-notification></gan-notification>
<gan-ops-notifications></gan-ops-notifications>

<div class="flex flex-col h-full min-h-full items-stretch">
  <div class="flex-none">
    <gan-header [msAccount]="msAccount$ | async" (logout)="onLogout()"></gan-header>
  </div>

  <div class="flex-auto relative min-h-0">
    <div class="h-full min-h-full">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
